import React, { Component, Suspense } from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from "@material-ui/core/styles";

import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/Visibility";
import CustomToolbar from "../common/AddButton";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import DriveEtaIcon from "@material-ui/icons/DriveEta";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import PolicyIcon from "@material-ui/icons/Policy";
import SlaIcon from "@material-ui/icons/AccessTime";
import ServicesIcon from "@material-ui/icons/Work";

import { withRouter } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { useTranslation, withTranslation, Trans } from "react-i18next";

import api from "../common/api";
//import { Store } from "../../flux";

class ContractsClass extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      open: false,
      dialogOpen: false,
      errors: false,
      tableStatePersist: {
        //Dynamic collection of props that are needed between table refreshes.
        searchText: "",
        filterList: [],
        columns: []
      }
    };
  }

  componentDidMount() {
    this.getContracts().then(result =>
      this.setState({
        data: Object.values(result)
      })
    );
  }

  getContracts = () => {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.contracts, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        this.setState({ isLoaded: true });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleClick = event => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
      rowId: event.currentTarget.dataset.id
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, open: false });
  };

  handleDelete() {
    const token = localStorage.getItem("userToken");
    return axios
      .delete(api.contract().get(this.state.rowId), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ message: "Contrato dado de baja con éxito!" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({
          message: "Hubo un problema al dar de baja el contrato."
        });
      });
  }

  handleDialogClose() {
    var state = this.state.dialogOpen;
    this.setState({ dialogOpen: !state });
    var contractname = "";
    this.state.data.map((val, idx) => {
      if (val.id == this.state.rowId) {
        contractname = val.name;
      }
    });
    var message =
      "Está a punto de dar de baja el contrato " +
      contractname +
      ". ¿Está seguro?";
    this.setState({ message: message });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 0px 0px 0px"
          }
        },
        MUIDataTable: {
          responsiveStacked: {
            overflow: "unset",
            overflowX: "unset"
          }
        }
      }
    });

  handleChange = (action, tableState) => {
    //console.log("CURRENT STATE: " + JSON.stringify(tableState));

    if (action !== "propsUpdate") {
      //Store new tableStatePersist only if not updating props
      this.setState({
        tableStatePersist: {
          searchText: tableState.searchText,
          filterList: tableState.filterList, //An array of filters for all columns
          columns: tableState.columns //We can pull column-specific options from this array, like display and sortDirection
        }
      });
    }
  };
  getSearchText = () => {
    return this.state.tableStatePersist.searchText;
  };

  getColumns = () => {
    //Define all of the alert table's columns and their default props and options as per the mui-datatables documentation
    let columns = [
      {
        name: "id",
        label: "id",
        options: {
          display: false,
          filter: false
        }
      },
      {
        name: "contact.client.business_name",
        label: "Cliente",
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: "name",
        label: "Nombre",
        options: {
          filter: true,
          sort: true,
          filterType: "textField"
        }
      },
      {
        name: "hansa_start_date",
        label: "Fecha de inicio",
        options: {
          filter: true,
          sort: true,
          filterType: "textField"
        }
      },
      {
        name: "hansa_end_date",
        label: "Fecha fin",
        options: {
          filter: true,
          sort: true,
          filterType: "textField"
        }
      },
      {
        name: "",
        label: "Acciones",
        options: {
          filter: false,
          setCellHeaderProps: () => ({ align: "right" }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0];
            //const rowId = 1
            return (
              <div
                className="row"
                style={{
                  display: "block",
                  textAlign: "right",
                  paddingRight: "30px"
                }}
              >
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none", backgroundColor: "green" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"contracts/view?id=" + rowId}
                >
                  <ViewIcon fontSize="small" />
                </Fab>
                <Fab
                  color="secondary"
                  aria-label="edit"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"contracts/edit?id=" + rowId}
                >
                  <EditIcon fontSize="small" />
                </Fab>
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  href={"contractVehicles?id=" + rowId}
                >
                  <DriveEtaIcon fontSize="small" />
                </Fab>
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  data-id={rowId}
                  onClick={this.handleClick}
                  style={{ padding: "5px" }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={this.state.anchorEl}
                  data-id={rowId}
                  index={tableMeta.columnIndex}
                  open={this.state.open}
                  onClose={this.handleClose}
                  PaperProps={{
                    style: {
                      maxHeight: "auto",
                      width: 250,
                      padding: "5px"
                    }
                  }}
                >
                  <MenuItem
                    onClick={this.handleClose}
                    style={{ fontSize: "0.875rem" }}
                  >
                    <Fab
                      color="primary"
                      aria-label="view"
                      variant="extended"
                      style={{ "box-shadow": "none" }}
                      fontSize="small"
                      className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                      href={
                        "authorizationMatrices?idContract=" + this.state.rowId
                      }
                    >
                      <ThumbUpIcon fontSize="small" />
                    </Fab>
                    <a
                      href={
                        "authorizationMatrices?idContract=" + this.state.rowId
                      }
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Matriz de Autorización
                    </a>
                  </MenuItem>
                  <MenuItem
                    onClick={this.handleClose}
                    style={{ fontSize: "0.875rem" }}
                  >
                    <Fab
                      color="primary"
                      aria-label="view"
                      variant="extended"
                      style={{ "box-shadow": "none", fontSize: "0.875rem" }}
                      fontSize="small"
                      className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                      href={"policies?idContract=" + this.state.rowId}
                    >
                      <PolicyIcon fontSize="small" />
                    </Fab>
                    <a
                      href={"policies?idContract=" + this.state.rowId}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Política de flota
                    </a>
                  </MenuItem>
                  <MenuItem
                    onClick={this.handleClose}
                    style={{ fontSize: "0.875rem" }}
                  >
                    <Fab
                      color="primary"
                      aria-label="view"
                      variant="extended"
                      style={{ "box-shadow": "none", fontSize: "0.875rem" }}
                      fontSize="small"
                      className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                      href={"sla?id=" + this.state.rowId}
                    >
                      <SlaIcon fontSize="small" />
                    </Fab>
                    <a
                      href={"sla?id=" + this.state.rowId}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      SLA
                    </a>
                  </MenuItem>
                  <MenuItem
                    onClick={this.handleClose}
                    style={{ fontSize: "0.875rem" }}
                  >
                    <Fab
                      color="primary"
                      aria-label="view"
                      variant="extended"
                      style={{ "box-shadow": "none", fontSize: "0.875rem" }}
                      fontSize="small"
                      className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                      href={"services/" + this.state.rowId}
                    >
                      <ServicesIcon fontSize="small" />
                    </Fab>
                    <a
                      href={"services/" + this.state.rowId}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Servicios contratados
                    </a>
                  </MenuItem>
                  <MenuItem
                    onClick={this.handleClose}
                    style={{ fontSize: "0.875rem" }}
                  >
                    <Fab
                      aria-label="delete"
                      variant="extended"
                      style={{ "box-shadow": "none", backgroundColor: "grey" }}
                      fontSize="small"
                      className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                      onClick={this.handleDialogClose.bind(this)}
                    >
                      <DeleteIcon fontSize="small" />
                    </Fab>
                    <a
                      onClick={this.handleDialogClose.bind(this)}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Dar de baja
                    </a>
                  </MenuItem>
                </Menu>
              </div>
            );
          }
        }
      }
    ];

    //Loop thru columns and assign all column-specific settings that need to persist thru a data refresh
    for (let i = 0; i < columns.length; i++) {
      //Assign the filter list to persist
      columns[i].options.filterList = this.state.tableStatePersist.filterList[
        i
      ];
      if (this.state.tableStatePersist.columns[i] !== undefined) {
        //If 'display' has a value in tableStatePersist, assign that, or else leave it alone
        if (this.state.tableStatePersist.columns[i].hasOwnProperty("display"))
          columns[i].options.display = this.state.tableStatePersist.columns[
            i
          ].display;
        //If 'sortDirection' has a value in tableStatePersist, assign that, or else leave it alone
        if (
          this.state.tableStatePersist.columns[i].hasOwnProperty(
            "sortDirection"
          )
        ) {
          //The sortDirection prop only permits sortDirection for one column at a time
          if (this.state.tableStatePersist.columns[i].sortDirection != "none")
            columns[
              i
            ].options.sortDirection = this.state.tableStatePersist.columns[
              i
            ].sortDirection;
        }
      }
    }

    return columns;
  };
  render() {
    const { t, i18n } = this.props;
    const changeLanguage = lng => {
      i18n.changeLanguage(lng);
    };
    const columns = [];

    const options = {
      searchText: this.getSearchText(),
      onTableChange: (action, tableState) =>
        this.handleChange(action, tableState),
      filter: true,
      selectableRows: true,
      filterType: "dropdown",
      responsive: "stacked",
      rowsPerPage: 10,
      customToolbar: () => {
        return <CustomToolbar url="new" />;
      },
      textLabels: {
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          ),
          toolTip: "Ordenar",
          columnHeaderTooltip: column => `Ordenar para ${column.label}`
        },
        filter: {
          all: "Todos los resultados",
          title: "Tus filtros",
          reset: "Resetear"
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Exportar CSV",
          print: "Imprimir",
          viewColumns: "Ver columnas",
          filterTable: "Filtros"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        }
      }
    };

    return (
      <div>
        <div className="col-12">
          <div className="row">
            <div className="col-md-6 text-left"></div>
            {/* <div className="col-md-6 text-right">
              <img width="30" className="mr-1 rounded d-inline" onClick={() => changeLanguage("en")} src={ require('../../images/usa_flag.png') } /> 
              <img width="30" className="mr-1 rounded d-inline" onClick={() => changeLanguage("es")} src={ require('../../images/argentina_flag.png') } />
            </div> */}
          </div>
        </div>
        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleDialogClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {!this.state.errors ? (
              <div>
                <Button
                  onClick={this.handleDialogClose.bind(this)}
                  color="primary"
                  autoFocus
                >
                  Cancelar
                </Button>
                <Button onClick={this.handleDelete.bind(this)} color="primary">
                  Continuar
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  onClick={this.handleDialogClose.bind(this)}
                  color="primary"
                >
                  Continuar
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
        <MuiThemeProvider theme={this.getMuiTheme()}>
          <MUIDataTable
            title={t("list_contracts")}
            data={Object.values(this.state.data)}
            columns={this.getColumns()}
            options={options}
          />
        </MuiThemeProvider>
      </div>
    );
  }
}

const Contracts = withTranslation()(ContractsClass);

export default function Contract() {
  return (
    <Suspense fallback={<CircularProgress />}>
      <Contracts />
    </Suspense>
  );
}
